import React from 'react';
import PropTypes from 'prop-types';
import {
  FDHeadlineText,
  FDPaper,
  FDAccordionGroup,
  FDSimpleAccordion,
} from '@facet-wealth/design';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import { DataValueMap } from 'Helpers/Testing';

export default function ScenarioSelectionFAQ({ faqResource }) {
  return (
    <FDPaper
      padding={3}
      maxWidth="600px"
      rounded
    >
      <FDHeadlineText size="lg" value={faqResource.attr('title')} />
      <FDAccordionGroup {...DataValueMap.init('faq-accordion-group').build()}>
        {faqResource.attr('questions').resources().list().map(el => (
          <FDSimpleAccordion
            key={el.id()}
            expansionID={el.id()}
            title={el.attr('question')}
          >
            <RichTextDisplay content={el.attr('answer')} />
          </FDSimpleAccordion>
        ))}
      </FDAccordionGroup>
    </FDPaper>
  );
}

ScenarioSelectionFAQ.defaultProps = {
};

ScenarioSelectionFAQ.propTypes = {
  faqResource: PropTypes.object.isRequired,
};
